import React from 'react';
import './DailySummary.css';
import { IcoChevU } from '../../icons/Icons';

export default function DailySummary({
  collapsed,
  onToggle,
  stats = { available: 0, occupied: 0, sales: 0, reserved: 0 },
}) {
  return (
    <section className={'sp-summary' + (collapsed ? ' is-collapsed' : '')} aria-label="Resumen">
      <div className="sp-summary-bar">
        <span className="sp-summary-title">Resumen del día</span>

        <div className="sp-summary-inline" aria-live="polite">
          <span><span className="sp-dot green" /> <b>{stats.available}</b> libres</span>
          <span><span className="sp-dot amber" /> <b>{stats.occupied}</b> ocupadas</span>
          <span><span className="sp-dot teal" /> <b>{stats.reserved}</b> reservada</span>
          <span><b> ${Number(stats.sales.toFixed(2)) || 0}</b> hoy</span>
        </div>

        <button
          className="sp-summary-toggle"
          aria-expanded={!collapsed}
          onClick={onToggle}
        >
          <span className="lbl">{collapsed ? 'Mostrar resumen' : 'Ocultar resumen'}</span>
          <IcoChevU />
        </button>
      </div>

      <div className="sp-kpis">
        <div className="sp-kpi">
          <div className="sp-kpi-label"><span className="sp-dot green" />Libres</div>
          <div className="sp-kpi-row">
            <div className="sp-kpi-value">{stats.available}</div>
            {/* <span className="sp-pill">{stats.ofTables}</span> */}
          </div>
        </div>

        <div className="sp-kpi">
          <div className="sp-kpi-label"><span className="sp-dot amber" />Ocupadas</div>
          <div className="sp-kpi-row">
            <div className="sp-kpi-value">{stats.occupied}</div>
            {/* <span className="sp-pill amber">afadfafa</span> */}
          </div>
        </div>

        <div className="sp-kpi">
          <div className="sp-kpi-label"><span className="sp-dot purple" />Reservadas</div>
          <div className="sp-kpi-row">
            <div className="sp-kpi-value">{stats.reserved}</div>
            {/* <span className="sp-pill purple">{stats.nextReservation}</span> */}
          </div>
        </div>

        <div className="sp-kpi">
          <div className="sp-kpi-label">Ventas de hoy</div>
          <div className="sp-kpi-row">
            <div className="sp-kpi-value">  ${Number(stats.sales.toFixed(2)) || 0}</div>
            {/* <span className="sp-pill green">{stats.salesDelta}</span> */}
          </div>
        </div>
      </div>
    </section>
  );
}